export default {

    Banks: 'البنك|البنوك',
};
